import { useEffect } from "react";
import { useArchViz } from "@/components/archviz/ArchVizContext";

export function useKeyboardShortcuts() {
  const { state, dispatch } = useArchViz();

  useEffect(() => {
    if (!state.architecture) return;
    const handler = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      const tag = target?.tagName.toLowerCase();
      if (tag === "input" || tag === "textarea" || target?.isContentEditable) return;

      switch (e.key) {
        case "Escape":
          if (state.selectedNodeId) {
            dispatch({ type: "SELECT_NODE", nodeId: null });
          } else {
            dispatch({ type: "DRILL_UP" });
          }
          break;
        case "f":
        case "F":
          dispatch({ type: "SET_FULLSCREEN", value: !state.fullscreen });
          break;
        case "1":
          dispatch({ type: "JUMP_TO_LEVEL", level: 1 });
          break;
        case "2":
          dispatch({ type: "JUMP_TO_LEVEL", level: 2 });
          break;
        case "3":
          if (state.selectedContainerId) {
            dispatch({ type: "JUMP_TO_LEVEL", level: 3 });
          }
          break;
        case " ":
          if (state.activeFlowId) {
            e.preventDefault();
            dispatch({ type: "TOGGLE_PLAY" });
          }
          break;
        case "ArrowRight":
          if (state.activeFlowId) {
            e.preventDefault();
            dispatch({ type: "STEP_FLOW", delta: 1 });
          }
          break;
        case "ArrowLeft":
          if (state.activeFlowId) {
            e.preventDefault();
            dispatch({ type: "STEP_FLOW", delta: -1 });
          }
          break;
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [state, dispatch]);
}
